import React from "react";
import { Link } from "react-router-dom";
import "./nev.css";

const Navebar = () => {
  const navebareitems = (
    <>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <a
          href="#About"
          data-rb-event-key="#project"
          class="menu-link nav-link"
        >
          About
        </a>
      </li>

      <li>
        <a
          href="#Projects"
          data-rb-event-key="#project"
          class="menu-link nav-link"
        >
          Projects
        </a>
      </li>
      <li>
        <Link to="/blog" class="menu-link nav-link">
          Bolg
        </Link>
      </li>
      <li>
        <a
          href="#contucts"
          data-rb-event-key="#project"
          class="menu-link nav-link"
        >
          Contact
        </a>
      </li>
    </>
  );

  return (
    <div className="navbar ">
      <div className="navbar-start">
        <Link
          to="/"
          style={{ fontFamily: `'Great Vibes', cursive` }}
          className="btn btn-ghost normal-case text-blue-400 text-3xl"
        >
          Rohit mondal
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0 text-2xl">{navebareitems}</ul>
      </div>
      <div className="navbar-end">
        <div className="dropdown dropdown-end mr-6 ">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu  bg-slate-600 text-white text-2xl menu-compact dropdown-content mt-3 p-2 shadow  rounded-box w-52"
          >
            {navebareitems}
          </ul>
        </div>

        <a
          target="blank"
          href="https://drive.google.com/file/d/1zuR54VEdeoPaH7otqDtUo1-lhpNGTRRT/view?usp=sharing"
          id="getbtn"
          className="btn"
        >
          Resume
        </a>
      </div>
    </div>
  );
};
export default Navebar;
